export { CardMedium } from './CardMedium';
export type { CardMediumProps } from './CardMedium';
